// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2qz0n","text":"SelectPayment_text__Pp3vH","title":"SelectPayment_title__5yxsW","btn":"SelectPayment_btn__1QBiF"};